import { ClientesService } from '@modules/clientes/services/clientes.service';
import { State, Setor } from '@shared/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultRequest } from '@shared/utils/consult-request';
import * as toastr from 'toastr'

@Component({
  selector: 'app-uf-combo',
  templateUrl: './uf-combo.component.html',
  styleUrls: ['./uf-combo.component.css'],
  providers: [ClientesService]
})
export class UfComboComponent implements OnInit {
  @Input() uf: State;
  @Output() ufChange = new EventEmitter<State>();

  statesRequest = new ConsultRequest<State[]>();

  private _setor: Setor = null;

  constructor(
    private clientesService: ClientesService,
  ) { }

  ngOnInit() {
  }

  get setor(){
    return this._setor;
  }


  get consultDisabled(){
    return !this.setor || this.statesRequest.isLoading;
  }

  @Input()
  get ufs() {
    return this.statesRequest.data;
  }
  set ufs(value: State[]) {
    this.statesRequest.data = value;
  }

  @Input()
  set setor(value: Setor | null){
    if(!value){
      this._setor = null;
    }else{
      this._setor = value;
    }

    this.getStates()
  }

  handleClick(event: MouseEvent){
    if(this.consultDisabled){
      event.preventDefault()

      if(this.statesRequest.isLoading){
        toastr.error('A combo ainda está carregando, tente mais tarde')
        return;
      }

      toastr.error('Para selecionar a uf, selecione o setor antes')
      return;
    }
  }

  handleUfChange(){
    this.ufChange.emit(this.uf)
  }

  // metodos privados

  private getStates() {
    this.reset();

    if(this.consultDisabled){
      return;
    }

    this.statesRequest.get(
      this.clientesService.getStates(this.setor.id)
    )
  }

  private reset(){
    this.statesRequest.reset()
    this.statesRequest.cancel()
    this.uf = null;
    setTimeout(()=>this.handleUfChange())
  }

}
